import tokenHttpClient from "../utils/httpClient";
import { post, postWithCSVResponse } from "../utils/httpClient-methods";
import {
  BASE_URL_MODEL_LIST,
  MODEL_VIEW_API_URL,
  BASE_URL_MODEL,
  BASE_URL_MASTERS,
  BRAND_LIST_API_URL,
  SPARE_API_URL,
  BASE_URL_SPARE_LIST,
  BASE_URL_SPARE,
} from "../utils/AppApiUrl";

export const ModelListingService = async (requestBody) => {
  try {
    const modelRequestObj = {
      modelSearchParam: {
        brandId: requestBody.modelSearchParam?.brandId,
        brickId: requestBody.modelSearchParam?.brickId,
        modelName: requestBody.modelSearchParam?.modelName,
        active: requestBody.modelSearchParam?.active,
      },
      modelPage: {
        pageNumber: requestBody.modelPage?.pageNumber,
        pageSize: requestBody.modelPage?.pageSize,
        sortDirection: requestBody.modelPage?.sortDirection,
        sortBy: requestBody.modelPage?.sortBy,
      },
    };
    const modelListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MODEL_LIST}${MODEL_VIEW_API_URL.modelListing}`,
      modelRequestObj
    );
    // add condition here to check
    if (modelListingResponse.status === 200) {
      return modelListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ModelListingOnSearchService = async (requestBody) => {
  try {
    const modelRequestObj = {
      modelSearchParam: {
        brandId: requestBody?.brandId,
        brickId: requestBody?.brickId,
        modelName:
          requestBody && requestBody.modelName === ""
            ? null
            : requestBody.modelName,
        active: requestBody?.active,
      },
      modelPage: {
        pageNumber: requestBody?.pageNumber,
        pageSize: requestBody?.pageSize,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
    };
    const modelListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MODEL_LIST}${MODEL_VIEW_API_URL.modelListing}`,
      modelRequestObj
    );
    // add condition here to check
    if (modelListingResponse.status === 200) {
      return modelListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ModelChangeStatusService = async (requestBody) => {
  try {
    const userStatusResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MODEL}${MODEL_VIEW_API_URL.changeModelStatus}`,
      requestBody
    );
    // add condition here to check
    if (userStatusResponse.status === 200) {
      return userStatusResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddModelService = async (values) => {
  try {
    const requestBody = {
      modelCode: values?.modelCode ?? "",
      fgCode: values?.fgCode ?? "",
      shortName: values?.shortName ?? "",
      modelDesc: values?.modelDesc ?? "",
      modelName: values?.modelName ?? "",
      brandID: values?.brandID ?? "",
      productFamilyId: values?.productFamilyId ?? null,
      active: values && values.active === false ? false : true,
      brickId: values?.brickId ?? null,
      createdOn: values?.createdOn ?? new Date(),
      createdBy: values?.createdBy ?? 1,
      modifiedBy: values?.modifedBy ?? null,
      modifiedOn: values?.modifiedOn ?? null,
    };
    const saveModelDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MODEL}${MODEL_VIEW_API_URL.saveModelDetails}`,
      requestBody
    );
    if (
      (saveModelDetails.status === 200 || saveModelDetails.status === 201)
    ) {
      return saveModelDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onEditModelService = async (values) => {
  try {
    const requestBody = {
      modelCode: values?.modelCode ?? "",
      fgCode: values?.fgCode ?? "",
      shortName: values?.shortName ?? "",
      modelDesc: values?.modelDesc ?? "",
      modelName: values?.modelName ?? "",
      brandID: values?.brandID ?? "",
      productFamilyId: values?.productFamilyId ?? null,
      active: values?.active,
      brickId: values?.brickId ?? null,
      modelId: values?.modelId ?? null,
      brandName: values?.brandName ?? "",
      brickName: values?.brickName ?? "",
      createdOn: values?.createdOn ?? null,
      createdBy: values?.createdBy ?? 1,
      modifiedBy: values?.modifiedBy ?? null,
      modifiedOn: new Date(),
    };
    const updateModelDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MODEL}${MODEL_VIEW_API_URL.updateModelDetails}`,
      requestBody
    );
    if (
      (updateModelDetails.status === 200 ||
        updateModelDetails.status === 201) 
    ) {
      return updateModelDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const brickListingOnSelectedBrandService = async (id) => {
  try {
    const param = {
      brandId: id ? id : 0,
    };
    const brickListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllBricksWithOrWithoutBrandId}`,
      param
    );
    // add condition here to check
    if (brickListingResponse.status === 200) {
      return brickListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const brandListingOnSelectedBrickService = async (id) => {
  try {
    const param = {
      brickId: id ? id : 0,
    };
    const brickListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllBrandsWithOrWithoutBrickId}`,
      param
    );
    // add condition here to check
    if (brickListingResponse.status === 200) {
      return brickListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};



export const SpareListingByModelIdService = async (requestBody) => {
  try {
    const modelRequestObj = {
      spareModelSearchParam: {
        modelId: requestBody.spareModelSearchParam?.modelId,
      },
      sparePage: {
        pageNumber: requestBody.sparePage?.pageNumber,
        pageSize: requestBody.sparePage?.pageSize,
        sortDirection: requestBody.sparePage?.sortDirection,
        sortBy: requestBody.sparePage?.sortBy,
      },
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${SPARE_API_URL.spareByModelId}`,
      modelRequestObj
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const FindSpareByArticleCodeService = async (articleCode) => {
  try {
    const param = {
      code: articleCode,
    };
    const response = await post(
      tokenHttpClient,      
      `${BASE_URL_SPARE}${SPARE_API_URL.findSpareByArticleCode}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const LinkSpareWithModelService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE}${SPARE_API_URL.linkSpareWithModel}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const CategoryListOnSelectedBrandService = async (brandId) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${MODEL_VIEW_API_URL.getCategoryWithBrandId}?brandId=${brandId}`,null
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadModelsService = async (requestBody) => {
  try {
    const param = {
      brandId: requestBody.brandId,
      brickId: requestBody.brickId,
      modelName: requestBody.modelName ?? null,
      active: requestBody.active,
    };
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL_MODEL_LIST}${MODEL_VIEW_API_URL.downloadModels}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
